import { useEffect, useState, useCallback } from "react";
import { api } from "../../../lib/api";
import { toast } from "sonner";
import { Upload, Trash2 } from "lucide-react";
import { BACKEND } from "./shared";

export function Documents({ reference }) {
  const [docs, setDocs] = useState([]);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const load = useCallback(() => {
    api.get(`/admin/booking/${reference}/documents`).then(r => setDocs(r.data.items || [])).catch(() => {});
  }, [reference]);
  useEffect(() => { load(); }, [load]);
  const upload = async () => {
    if (!file) { toast.error("Choose a file"); return; }
    setUploading(true);
    try {
      const fd = new FormData(); fd.append("file", file);
      await api.post(`/admin/booking/${reference}/document`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Document uploaded to client"); setFile(null); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Upload failed"); }
    setUploading(false);
  };
  const del = async (id) => { try { await api.delete(`/admin/document/${id}`); load(); } catch { toast.error("Cannot delete"); } };
  return (
    <div data-testid="jobfile-documents">
      <div className="border border-[#E5E7EB] bg-white p-3 mb-4 flex flex-col sm:flex-row gap-2 items-center">
        <label className="de-btn-secondary cursor-pointer inline-flex shrink-0"><Upload size={16} /> {file ? file.name.slice(0, 18) : "Choose file"}
          <input data-testid="doc-input" type="file" className="hidden" onChange={e => setFile(e.target.files?.[0])} /></label>
        <button data-testid="doc-upload" onClick={upload} disabled={uploading} className="de-btn-primary shrink-0">{uploading ? "…" : "Upload to client"}</button>
      </div>
      <div className="space-y-2">
        {docs.length === 0 && <div className="text-sm text-[#6B7280]">No documents yet. Invoices &amp; receipts are generated automatically when the deposit is paid.</div>}
        {docs.map(d => (
          <div key={d.id} data-testid={`doc-${d.id}`} className="flex items-center gap-2 border border-[#E5E7EB] bg-white px-3 py-2.5 text-sm">
            <a href={`${BACKEND}/api/admin/document/${d.id}`} target="_blank" rel="noreferrer" className="flex-1 truncate hover:text-[#C79A3B]">{d.filename}</a>
            <span className="text-[10px] uppercase tracking-wider text-[#6B7280]">{d.type}</span>
            <button data-testid={`doc-delete-${d.id}`} onClick={() => del(d.id)} className="text-[#6B7280] hover:text-[#C79A3B]"><Trash2 size={14} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
